import { request } from '../utils';
import {
    MAIL_SETUP,
    SHOW_MAILER,
    UPDATE_MAILER,
    MAIL_SENDER,
    SEND_TEST_MAIL,
    MAILER_INSIGHTS,
    UNDO_MAILER_CONTENT,
    POST_PRE_LAUNCH,
    BENEFIT_ADOPTION_MAILERS,
    CLONE_MAILER,
    CANCEL_SCHEDULED_MAILER
} from '../routes/api'

const getContractId = () => {
    return(sessionStorage.getItem('contract_id'))
} 

class companyMailerApi {
    static mail_steup(options, onSuccess, onError) {
        return request({url: MAIL_SETUP(getContractId()), method: 'get', ...options}, onSuccess, onError);
    }

    static test_mail(options, onSuccess, onError) {
        return request({ url: SEND_TEST_MAIL(getContractId(), options.id), method: 'post', ...options }, onSuccess, onError);
    }

    static update_mailer(options, onSuccess, onError) {
        return request({ url: UPDATE_MAILER(getContractId(), options.id), method: 'patch', ...options }, onSuccess, onError);
    }

    static show_mailer(options, onSuccess, onError) {
        return request({ url: SHOW_MAILER(getContractId(), options.id), method: 'get', ...options }, onSuccess, onError);
    }

    static mailer_insights(options, onSuccess, onError) {
        return request({url: MAILER_INSIGHTS(getContractId()), method: 'get', ...options}, onSuccess, onError)
    }

    static mailer_sender(options, onSuccess, onError) {
        return request({url: MAIL_SENDER(getContractId(), options.id), method: 'get', ...options}, onSuccess, onError)
    }

    static revert_to_original(options, onSuccess, onError) {
        return request({url: UNDO_MAILER_CONTENT(getContractId(), options.id), method: 'get', ...options}, onSuccess, onError)
    }

    static post_pre_launch(options, onSuccess, onError) {
        return request({url: POST_PRE_LAUNCH(getContractId(), options.id), method: 'get', ...options}, onSuccess, onError)
    }

    static benefit_adoption_mailers(options, onSuccess, onError) {
        return request({url: BENEFIT_ADOPTION_MAILERS(getContractId()), method: 'get', ...options}, onSuccess, onError)
    }

    static clone_mailer(options, onSuccess, onError) {
        return request({url: CLONE_MAILER(getContractId(), options.id), method: 'get', ...options}, onSuccess, onError)
    }

    static cancel_schedule_mailer(options, onSuccess, onError) {
        return request({url: CANCEL_SCHEDULED_MAILER(getContractId(), options.id), method: 'get', ...options}, onSuccess, onError)
    }

}

export default companyMailerApi;
